import { render, staticRenderFns } from "./depoList.vue?vue&type=template&id=2a7bfb2f&scoped=true&"
import script from "./depoList.vue?vue&type=script&lang=js&"
export * from "./depoList.vue?vue&type=script&lang=js&"
import style0 from "./depoList.vue?vue&type=style&index=0&id=2a7bfb2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7bfb2f",
  null
  
)

export default component.exports